import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { I18nModule } from '@spartacus/core';
import { PopoverModule } from '../popover';
import { TooltipIconComponent } from './tooltip-icon.component';

@NgModule({
  declarations: [TooltipIconComponent],
  imports: [CommonModule, MatIconModule, PopoverModule, I18nModule],
  exports: [TooltipIconComponent],
})
export class TooltipIconModule {}
